import { Dropdown, Option, Tooltip, makeStyles, tokens } from '@fluentui/react-components';
import { PeopleTeamRegular } from '@fluentui/react-icons';

import { ROLE_OPTIONS, TRole } from '../../models';
import { useChangeV2Store } from '../../state/ChangeV2Store';

const useStyles = makeStyles({
  root: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalXS },
  icon: { color: tokens.colorNeutralForeground3 },
  dropdown: { minWidth: '210px' },
});

// Prototype role switcher. Changing role affects permissions while action
// attribution continues to use the signed-in user.
export const PrototypeRoleSwitcher = () => {
  const classes = useStyles();
  const { role, setRole } = useChangeV2Store();
  return (
    <div className={classes.root}>
      <Tooltip content="Prototype role" relationship="label">
        <PeopleTeamRegular className={classes.icon} />
      </Tooltip>
      <Dropdown
        aria-label="Prototype role"
        className={classes.dropdown}
        selectedOptions={[role]}
        value={role}
        onOptionSelect={(_, data) => setRole(data.optionValue as TRole)}
      >
        {ROLE_OPTIONS.map((option) => (
          <Option key={option.value} value={option.value} text={option.value}>
            {option.value}
          </Option>
        ))}
      </Dropdown>
    </div>
  );
};
